var __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/es/object/entries");